import { render, staticRenderFns } from "./orderFormBoxV2.vue?vue&type=template&id=55b5b6a8&scoped=true"
import script from "./orderFormBoxV2.vue?vue&type=script&lang=js"
export * from "./orderFormBoxV2.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b5b6a8",
  null
  
)

export default component.exports